package team.platforma.materialextension.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import team.platforma.multiplatform_material_extension.toolbar.AppToolbarStyle
import team.platforma.multiplatform_material_extension.toolbar.ToolbarStyle

class ToolbarTheme {
    @Composable
    fun light() {
        ToolbarStyle.define(
            toolbarStyle = AppToolbarStyle(
                containerColor = Color.Red
            )
        )
    }

    @Composable
    fun dark() {
        ToolbarStyle.define(
            toolbarStyle = AppToolbarStyle(
                containerColor = Color.Blue
            )
        )
    }
}